<div class="card" [attr.data-testid]="testId()">
  <div class="flex flex-wrap justify-between items-center gap-4">
    <h3 class="text-xl">{{ titleKey() | transloco }}</h3>

    <div class="flex items-center gap-3">
      <label [for]="testId() + '-equal-weights'" class="text-sm">
        {{ equalForAllKey() | transloco }}
      </label>
      <p-toggleswitch
        [inputId]="testId() + '-equal-weights'"
        [ngModel]="equalWeights()"
        [disabled]="disabled()"
        [attr.data-testid]="testId() + '-equal-weights-toggle'"
        (ngModelChange)="onEqualWeightsChange($event)"
      ></p-toggleswitch>
    </div>
  </div>

  <div class="mt-6" [class.opacity-50]="equalWeights()">
    <p-selectButton
      optionValue="value"
      [options]="modeOptions()"
      [allowEmpty]="false"
      [ngModel]="mode()"
      [disabled]="modeSelectionDisabled()"
      [attr.data-testid]="testId() + '-mode'"
      (ngModelChange)="onModeChange($event)"
    >
      <ng-template #item let-option>
        <span [attr.data-testid]="testId() + '-mode-' + option.value">
          {{ option.translationKey | transloco }}
        </span>
      </ng-template>
    </p-selectButton>
  </div>

  @if (equalWeights()) {
    <p class="mt-4 text-sm opacity-80" [attr.data-testid]="testId() + '-equal-weights-hint'">
      {{ equalForAllHintKey() | transloco }}
    </p>
  }

  @if (showsRanking()) {
    <app-criteria-ranking-x
      class="block mt-6"
      [translationKeyPrefix]="translationKeyPrefix()"
      [testId]="testId() + '-ranking'"
      [rankedItems]="workingRanking()"
      [disabled]="disabled()"
      (rankingChanged)="onRankingChanged($event)"
    ></app-criteria-ranking-x>

    @if (showsRankingSaveButton()) {
      <div class="flex justify-end gap-2 mt-3">
        <app-project-step-save-button
          [loading]="saving()"
          [disabled]="saving()"
          (clicked)="onRankingSave()"
        ></app-project-step-save-button>
      </div>
    }
  }

  @if (showsPairwise()) {
    <app-pairwise-block-x
      class="block mt-6"
      [translationKeyPrefix]="translationKeyPrefix()"
      [identifierPrefix]="identifierPrefix()"
      [testId]="testId() + '-pairwise'"
      [items]="items()"
      [comparisons]="comparisons()"
      [disabled]="disabled()"
      [saving]="saving()"
      (save)="onComparisonsSave($event)"
    ></app-pairwise-block-x>
  }

  <app-audit-info [auditInfo]="auditInfo()" />
</div>

@if (showsSummary()) {
  <app-weighting-summary-x
    class="block mt-5"
    [title]="summaryTitleKey()"
    [testId]="testId() + '-summary'"
    [ranking]="ranking()"
  ></app-weighting-summary-x>
}
